import React from "react";

import { useTranslation } from "react-i18next";

import { Drawer } from "components/Drawer";
import SearchEmpty from "components/SearchEmpty";

import { handleChangeLogHtml } from "./constants";
import { IChangeLogProps } from "./interfaces";
import { LoadSpinner } from "../../../features/LoadSpinner";

export const ChangeLog: React.FC<IChangeLogProps> = ({
  changeLogModal,
  setChangeLogModal,
  changeLogData,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      open={changeLogModal}
      onClose={() => setChangeLogModal(false)}
      title={t("profile.whatsNew")}
      footer="none"
      paddingBottom={12}
      paddingLeft={12}
      paddingRight={20}
      paddingTop={12}
    >
      {changeLogData !== undefined ? (
        handleChangeLogHtml(changeLogData)
      ) : (
        <>
          <SearchEmpty
            textMessage={t("profile.noVersionAvailable")}
            typeIcon={"file"}
          />
          <LoadSpinner loading={true} />
        </>
      )}
    </Drawer>
  );
};
